<template>
  <div class="flight">
    <div class="flight__holder">
      <div class="flight__part">
        <div class="flight__icon">
          <img :src="require(`@/assets/img/${getArrivalType}-icon.svg`)" alt="Arrival icon">
        </div>
        <div class="flight__info">
          <div class="flight__title">
            <app-cells :indent="false">
              <div class="flight__icons">
                <span>Arrival</span>
                <img
                    v-if="transport.arrival.arrival_confirmed"
                    src="@/assets/img/flight-confirmed.svg"
                    alt="Confirmed"
                    v-tooltip="{content: 'Confirmed', placement: 'top', offset: 10}"
                >
                <img
                    v-if="transport.arrival.arrival_flight_domestic"
                    src="@/assets/img/glyph-icon.svg"
                    alt=""
                    v-tooltip="{content: 'Domestic flight', placement: 'top', offset: 10}"
                >
              </div>
            </app-cells>
            <button
              v-if="transport.arrival.arrival_method && (is_general_manager || is_sales_manager || is_sales_supervisor)"
              @click="onShowModal('arrival')"
              class="flight__button"
            >
              Edit
            </button>
          </div>
          <div class="flight__date">
            <span v-if="transport.arrival.arrival_method">
              {{ formatDate(transport.arrival.arrival_date) }}, {{ transport.arrival.arrival_time }}
            </span>
            <span v-else>No info</span>
          </div>
          <span v-if="!transport.arrival.arrival_method" class="flight__note flight__note--red">
            Add details about client arrival
          </span>
          <button
            v-if="!transport.arrival.arrival_method && (is_general_manager || is_sales_manager || is_sales_supervisor)"
            @click="onShowModal('arrival')"
            class="flight__button flight__button--add"
          >
            Add
          </button>
          <div v-if="transport.arrival.arrival_company" class="flight__name">
            {{ transport.arrival.arrival_company.name }}
            <span v-if="transport.arrival.arrival_flight_number"> - {{ transport.arrival.arrival_flight_number }}</span>
          </div>
          <div class="flight__location">
            {{ transport.arrival.arrival_location ? transport.arrival.arrival_location.name: '' }}
          </div>
        </div>
      </div>
      <div class="flight__part">
        <div class="flight__icon">
          <img :src="require(`@/assets/img/${getDepartureType}-icon.svg`)" alt="Arrival icon">
        </div>
        <div class="flight__info">
          <div class="flight__title">
            <div class="flight__icons">
              <span>Departure</span>
              <img
                  v-if="transport.departure.departure_confirmed"
                  src="@/assets/img/flight-confirmed.svg"
                  alt="Confirmed"
                  v-tooltip="{content: 'Confirmed', placement: 'top', offset: 10}"
              >
              <img
                  v-if="transport.departure.departure_flight_domestic"
                  src="@/assets/img/glyph-icon.svg"
                  alt=""
                  v-tooltip="{content: 'Domestic flight', placement: 'top', offset: 10}"
              >
            </div>
            <button
              v-if="transport.departure.departure_method && (is_general_manager || is_sales_manager || is_sales_supervisor)"
              @click="onShowModal('departure')"
              class="flight__button"
            >
              Edit
            </button>
          </div>
          <div class="flight__date">
            <span v-if="transport.departure.departure_method">
              {{ formatDate(transport.departure.departure_date) }}, {{ transport.departure.departure_time }}
            </span>
            <span v-else>No info</span>
          </div>
          <span v-if="!transport.departure.departure_method" class="flight__note flight__note--red">
            Add details about client departure
          </span>
          <button
            v-if="!transport.departure.departure_method && (is_general_manager || is_sales_manager || is_sales_supervisor)"
            @click="onShowModal('departure')"
            class="flight__button flight__button--add"
          >
            Add
          </button>
          <div v-if="transport.departure.departure_company" class="flight__name">
            {{ transport.departure.departure_company.name }}
            <span v-if="transport.departure.departure_flight_number"> - {{ transport.departure.departure_flight_number }}</span>
          </div>
          <div class="flight__location">
            {{ transport.departure.departure_location ? transport.departure.departure_location.name : '' }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="transport.arrival.arrival_notes || transport.departure.departure_notes"
      class="flight__footer"
    >
      <div v-if="transport.arrival.arrival_notes || transport.departure.departure_notes" class="flight__footer-left">
        <button
          class="flight__additional"
          v-tooltip="{content: tooltipContent, placement: 'right', offset: 10, html: true}"
        >
          <img src="@/assets/img/flight-note.svg" alt="Additional">
          <span>Additional notes</span>
        </button>
      </div>
    </div>
    <modal
      name="transport-modal"
      :width="774"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".modal-transport__title"
      :reset="true"
    >
      <div class="modal-transport">
        <button @click="onHideModal" class="modal-transport__close" type="button"></button>
        <div v-show="transport_modal_type === 'arrival'" class="modal-transport__part">
          <div class="modal-transport__top">
            <div class="modal-transport__title">
              <img :src="require(`@/assets/img/${getArrivalTypeModal}-icon.svg`)" alt="Arrival icon">
              <span>Arrival details</span>
            </div>
            <app-checkbox
              v-model="form.arrival_confirmed"
              label="Confirmed"
              v-tooltip="{ content: 'Checking this box will disable editing for client', placement: 'top-start', offset: 10, container: false }"
            />
            <app-checkbox
              v-show="form.arrival_confirmed"
              v-model="form.arrival_no_transfer"
              label="No transfer"
              @change.native="onChangeNoTransfer('arrival')"
            />
            <app-select
              v-show="form.arrival_confirmed && form.arrival_no_transfer"
              v-model="form.arrival_no_transfer_reason"
              :options="reasons_options"
              :clearable="false"
              placeholder="Choose reason"
              class="select--200"
              :error="$v.form.arrival_no_transfer_reason.$error"
            />
          </div>
          <div class="modal-transport__row modal-transport__row--1">
            <app-form-group label="Transport mode" required>
              <app-select
                @input="onChangeTransportMethod('arrival')"
                v-model="form.arrival_method"
                :reduce="item => item.code"
                :options="transport_options"
                :filterable="false"
                :clearable="false"
                :searchable="false"
                :readonly="form.arrival_confirmed"
                placeholder="Transport mode"
                :error="$v.form.arrival_method.$error"
              />
              <template #error>
                <div v-if="$v.form.arrival_method.$dirty && !$v.form.arrival_method.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Date" required>
              <app-date-picker
                v-model="form.arrival_date"
                :readonly="form.arrival_confirmed"
                placeholder="Date"
                :error="$v.form.arrival_date.$error"
              />
              <template #error>
                <div v-if="$v.form.arrival_date.$dirty && !$v.form.arrival_date.required">Required field</div>
                <div v-if="$v.form.arrival_date.$dirty && !$v.form.arrival_date.minValue">
                  Date cannot be less than the current date
                </div>
              </template>
            </app-form-group>
            <app-form-group label="Time" label-for="arrival-time" required>
              <app-input
                v-model="form.arrival_time"
                v-mask="'99:99'"
                placeholder="Time"
                autocomplete="off"
                id="arrival-time"
                name="arrival_time"
                @paste.native.prevent
                :error="$v.form.arrival_time.$error"
                :readonly="form.arrival_confirmed"
              />
              <template #error>
                <div v-if="$v.form.arrival_time.$dirty && !$v.form.arrival_time.required">Required field</div>
                <div v-if="$v.form.arrival_time.$dirty && !$v.form.arrival_time.timeRegex">Wrong time</div>
              </template>
            </app-form-group>
            <app-form-group label="Location" required>
              <app-select
                @input="onArrivalLocationSelected"
                @search="onLocationSearch"
                v-model="form.arrival_location"
                :options="location_options"
                :clearable="false"
                :readonly="form.arrival_confirmed"
                placeholder="Location"
                :error="$v.form.arrival_location.$error"
              />
              <template #error>
                <div v-if="$v.form.arrival_location.$dirty && !$v.form.arrival_location.required">Required field</div>
              </template>
            </app-form-group>
          </div>
          <div class="modal-transport__row modal-transport__row--2">
            <app-form-group
              v-show="form.arrival_method === 'flight' || form.arrival_method === 'bus'"
              :label="form.arrival_method === 'flight' ? 'Airline' : 'Bus company'"
              required
            >
              <app-select
                v-model="form.arrival_company"
                :reduce="item => item.id"
                :options="company_options.filter(item => item.type === form.arrival_method)"
                :clearable="false"
                :readonly="form.arrival_confirmed"
                placeholder="Company"
                :error="$v.form.arrival_company.$error"
              />
              <template #error>
                <div v-if="$v.form.arrival_company.$dirty && !$v.form.arrival_company.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group v-show="form.arrival_method === 'flight'" label="Flight number" label-for="arrival-flight" required>
              <app-input
                v-model="form.arrival_flight_number"
                placeholder="Flight"
                id="arrival-flight"
                :error="$v.form.arrival_flight_number.$error"
                :readonly="form.arrival_confirmed"
                name="arrival_flight"
              />
              <template #error>
                <div v-if="$v.form.arrival_flight_number.$dirty && !$v.form.arrival_flight_number.required">
                  Required field
                </div>
                <div v-if="$v.form.arrival_flight_number.$dirty && !$v.form.arrival_flight_number.flightNumberRegex">
                  Only latin letters, numbers and '-' are allowed
                </div>
              </template>
            </app-form-group>
            <app-form-group v-show="form.arrival_method === 'flight'" label="Domestic" class="form-group--switcher">
              <app-switcher v-model="form.arrival_flight_domestic" :readonly="form.arrival_confirmed" />
            </app-form-group>
          </div>
          <div class="modal-transport__row">
            <app-form-group label="Additional notes" label-for="arrival-notes">
              <app-input
                  v-model="form.arrival_notes"
                  placeholder="Additional notes"
                  id="arrival-notes"
                  :readonly="form.arrival_confirmed"
                  name="arrival_notes"
              />
            </app-form-group>
          </div>
          <div class="modal-transport__row modal-transport__row--1">
            <app-form-group v-if="form.arrival_method === 'flight'" label="Tickets">
              <app-uploader
                  v-model="form.arrival_ticket"
                  :readonly="form.arrival_confirmed"
                  class="custom-uploader--flex"
                  :extensions="['application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
              />
            </app-form-group>
          </div>
        </div>
        <div v-show="transport_modal_type === 'departure'" class="modal-transport__part">
          <div class="modal-transport__top">
            <div class="modal-transport__title">
              <img :src="require(`@/assets/img/${getDepartureTypeModal}-icon.svg`)" alt="Arrival icon">
              <span>Departure details</span>
            </div>
            <app-checkbox
              v-model="form.departure_confirmed"
              label="Confirmed"
              v-tooltip="{ content: 'Checking this box will disable editing for client', placement: 'top-start', offset: 10, container: false }"
            />
            <app-checkbox
              v-show="form.departure_confirmed"
              v-model="form.departure_no_transfer"
              label="No transfer"
              @change.native="onChangeNoTransfer('departure')"
            />
            <app-select
              v-show="form.departure_confirmed && form.departure_no_transfer"
              v-model="form.departure_no_transfer_reason"
              :options="reasons_options"
              :clearable="false"
              placeholder="Choose reason"
              class="select--200"
              :error="$v.form.departure_no_transfer_reason.$error"
            />
          </div>
          <div class="modal-transport__row modal-transport__row--1">
            <app-form-group label="Transport mode" required>
              <app-select
                @input="onChangeTransportMethod('departure')"
                v-model="form.departure_method"
                :options="transport_options"
                :reduce="item => item.code"
                :filterable="false"
                :clearable="false"
                :searchable="false"
                :readonly="form.departure_confirmed"
                placeholder="Transport mode"
                :error="$v.form.departure_method.$error"
              />
              <template #error>
                <div v-if="$v.form.departure_method.$dirty && !$v.form.departure_method.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Date" required>
              <app-date-picker
                v-model="form.departure_date"
                :readonly="form.departure_confirmed"
                placeholder="Date"
                :error="$v.form.departure_date.$error"
              />
              <template #error>
                <div v-if="$v.form.departure_date.$dirty && !$v.form.departure_date.required">Required field</div>
                <div v-if="$v.form.departure_date.$dirty && !$v.form.departure_date.minValue">
                  Date cannot be less than the current date
                </div>
              </template>
            </app-form-group>
            <app-form-group label="Time" label-for="arrival-time" required>
              <app-input
                v-model="form.departure_time"
                v-mask="'99:99'"
                placeholder="Time"
                autocomplete="off"
                id="arrival-time"
                name="arrival_time"
                @paste.native.prevent
                :error="$v.form.departure_time.$error"
                :readonly="form.departure_confirmed"
              />
              <template #error>
                <div v-if="$v.form.departure_time.$dirty && !$v.form.departure_time.required">Required field</div>
                <div v-if="$v.form.departure_time.$dirty && !$v.form.departure_time.timeRegex">Wrong time</div>
              </template>
            </app-form-group>
            <app-form-group label="Location" required>
              <app-select
                @input="onDepartureLocationSelected"
                @search="onLocationSearch"
                v-model="form.departure_location"
                :options="location_options"
                :clearable="false"
                :readonly="form.departure_confirmed"
                placeholder="Location"
                :error="$v.form.departure_location.$error"
              />
              <template #error>
                <div v-if="$v.form.departure_location.$dirty && !$v.form.departure_location.required">Required field</div>
              </template>
            </app-form-group>
          </div>
          <div class="modal-transport__row modal-transport__row--2">
            <app-form-group
              v-show="form.departure_method === 'flight' || form.departure_method === 'bus'"
              :label="form.departure_method === 'flight' ? 'Airline' : 'Bus company'"
              required
            >
              <app-select
                v-model="form.departure_company"
                :reduce="item => item.id"
                :options="company_options.filter(item => item.type === form.departure_method)"
                :clearable="false"
                :readonly="form.departure_confirmed"
                placeholder="Company"
                :error="$v.form.departure_company.$error"
              />
              <template #error>
                <div v-if="$v.form.departure_company.$dirty && !$v.form.departure_company.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group v-show="form.departure_method === 'flight'" label="Flight number" label-for="departure-flight" required>
              <app-input
                v-model="form.departure_flight_number"
                placeholder="Flight"
                id="departure-flight"
                :error="$v.form.departure_flight_number.$error"
                :readonly="form.departure_confirmed"
                name="departure_flight"
              />
              <template #error>
                <div v-if="$v.form.departure_flight_number.$dirty && !$v.form.departure_flight_number.required">
                  Required field
                </div>
                <div v-if="$v.form.departure_flight_number.$dirty && !$v.form.departure_flight_number.flightNumberRegex">
                  Only latin letters, numbers and '-' are allowed
                </div>
              </template>
            </app-form-group>
            <app-form-group v-show="form.departure_method === 'flight'" label="Domestic" class="form-group--switcher">
              <app-switcher v-model="form.departure_flight_domestic" :readonly="form.departure_confirmed" />
            </app-form-group>
          </div>
          <div class="modal-transport__row">
            <app-form-group label="Additional notes" label-for="departure-notes">
              <app-input
                  v-model="form.departure_notes"
                  placeholder="Additional notes"
                  id="departure-notes"
                  :readonly="form.departure_confirmed"
                  name="departure_notes"
              />
            </app-form-group>
          </div>
          <div class="modal-transport__row modal-transport__row--1">
            <app-form-group v-if="form.departure_method === 'flight'" label="Tickets">
              <app-uploader
                  v-model="form.departure_ticket"
                  :readonly="form.departure_confirmed"
                  class="custom-uploader--flex"
                  :extensions="['application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
              />
            </app-form-group>
          </div>
        </div>
        <app-cells position="end">
          <app-button @click.native="onCheckForm" :disabled="$v.form.$error" ref="submitTransport">Save</app-button>
        </app-cells>
      </div>
    </modal>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import {
  getArrivalCompanies,
  getArrivalMethods,
  getGoogleSearch,
  getReasonsNoTransfers,
  patchClients,
  postLocation,
} from '@/http'
import debounce from 'lodash/debounce'
import { helpers, required, requiredIf } from 'vuelidate/lib/validators'

const flightNumberRegex = helpers.regex('flightNumberRegex', /^[a-zA-Z0-9-]*$/i)
const timeRegex = helpers.regex('timeRegex', /^([0-1][0-9]|2[0-3]):([0-5][0-9])?$/i)

export default {
  name: 'Flight',
  props: {
    transport: Object,
  },
  data() {
    return {
      form: {},
      transport_options: [],
      location_options: [],
      company_options: [],
      transport_modal_type: '',
      reasons_options: [],
    }
  },
  validations() {
    const form = {
      arrival_method: {},
      arrival_date: {},
      arrival_time: {},
      arrival_location: {},
      arrival_company: {},
      arrival_flight_number: {},
      arrival_no_transfer_reason: {},
      departure_method: {},
      departure_date: {},
      departure_time: {},
      departure_location: {},
      departure_company: {},
      departure_flight_number: {},
      departure_no_transfer_reason: {},
    }
    if (this.transport_modal_type === 'arrival') {
      form.arrival_method = { required }
      form.arrival_date = {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        }
      }
      form.arrival_time = {
        required,
        timeRegex
      }
      form.arrival_location = { required }
      form.arrival_company = {
        required: requiredIf(function() {
          return this.form.arrival_method === 'flight' || this.form.arrival_method === 'bus'
        })
      }
      form.arrival_flight_number = {
        required: requiredIf(function() {
          return this.form.arrival_method === 'flight'
        }),
        flightNumberRegex
      }
      form.arrival_no_transfer_reason = {
        required: requiredIf(function() {
          return this.form.arrival_no_transfer
        }),
      }
    }
    if (this.transport_modal_type === 'departure') {
      form.departure_method = { required }
      form.departure_date = {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        }
      }
      form.departure_time = {
        required,
        timeRegex
      }
      form.departure_location = { required }
      form.departure_company = {
        required: requiredIf(function() {
          return this.form.departure_method === 'flight' || this.form.departure_method === 'bus'
        })
      }
      form.departure_flight_number = {
        required: requiredIf(function() {
          return this.form.departure_method === 'flight'
        }),
        flightNumberRegex
      }
      form.departure_no_transfer_reason = {
        required: requiredIf(function() {
          return this.form.departure_no_transfer
        }),
      }
    }

    return {
      form
    }
  },
  computed: {
    getArrivalType() {
      return this.transport.arrival.arrival_method?.code || 'unknown'
    },
    getDepartureType() {
      return this.transport.departure.departure_method?.code || 'unknown'
    },
    getArrivalTypeModal() {
      return this.form.arrival_method || 'unknown'
    },
    getDepartureTypeModal() {
      return this.form.departure_method || 'unknown'
    },
    tooltipContent() {
      const arrivalTemplate = this.transport.arrival.arrival_notes ? `<b>Arrival</b><span>${this.transport.arrival.arrival_notes}</span>` : ''
      const departureTemplate = this.transport.departure.departure_notes ? `<b>Departure</b><span>${this.transport.departure.departure_notes}</span>` : ''
      return `${arrivalTemplate}${departureTemplate}`
    },
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_sales_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
  },
  watch: {
    transport: {
      handler(obj) {
        if (obj) {
          this.form = {
            ...{...obj.arrival, arrival_method: obj.arrival.arrival_method?.code},
            ...{...obj.departure, departure_method: obj.departure.departure_method?.code},
          }
        }
      },
      immediate: true,
    }
  },
  created() {
    getArrivalMethods().then(response => { this.transport_options = response.data })
    getArrivalCompanies().then(response => { this.company_options = response.data })
    getReasonsNoTransfers().then(response => { this.reasons_options = response.data })
  },
  methods: {
    onChangeNoTransfer(type) {
      if (type === 'arrival' && !this.form.arrival_no_transfer) this.form.arrival_no_transfer_reason = null
      if (type === 'departure' && !this.form.departure_no_transfer) this.form.departure_no_transfer_reason = null
    },
    onArrivalLocationSelected({ name, place_id }) {
      this.$refs.submitTransport.preload = true
      postLocation({ name, place_id }).then(res => {
        this.form.arrival_location = res.data
        this.$refs.submitTransport.preload = false
      })
    },
    onDepartureLocationSelected({ name, place_id }) {
      this.$refs.submitTransport.preload = true
      postLocation({ name, place_id }).then(res => {
        this.form.departure_location = res.data
        this.$refs.submitTransport.preload = false
      })
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submitTransport.preload = true
      patchClients(this.$route.params.id, this.normalizeForm())
        .finally(() => { this.$refs.submitTransport.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transport changed',
          })
          this.onHideModal()
          this.$emit('update')
        })
    },
    normalizeForm() {
      const form = {...this.form}
      if (this.transport_modal_type === 'arrival') {
        delete form.departure_company
        delete form.departure_confirmed
        delete form.departure_flight_number
        delete form.departure_location
        delete form.departure_method
        delete form.departure_notes
        delete form.departure_time
        delete form.departure_date
        delete form.departure_confirmed
        delete form.departure_ticket
        delete form.departure_no_transfer
        delete form.departure_no_transfer_reason
        if (form.arrival_method !== 'flight') {
          form.arrival_flight_number = null
          form.arrival_ticket = null
          form.arrival_flight_domestic = false
        } else {
          if (form.arrival_ticket && form.arrival_ticket.file) form.arrival_ticket = form.arrival_ticket.id
          else form.arrival_ticket = null
        }
        if (form.arrival_method !== 'flight' && form.arrival_method !== 'bus') form.arrival_company = null
        if (form.arrival_company && typeof form.arrival_company === 'object') form.arrival_company = form.arrival_company.id
        if (form.arrival_location) form.arrival_location = form.arrival_location.id
        if (form.arrival_no_transfer_reason) form.arrival_no_transfer_reason = form.arrival_no_transfer_reason.code
        if (!form.arrival_confirmed) {
          form.arrival_no_transfer = false
          form.arrival_no_transfer_reason = null
        }
      }
      if (this.transport_modal_type === 'departure') {
        delete form.arrival_company
        delete form.arrival_confirmed
        delete form.arrival_flight_number
        delete form.arrival_location
        delete form.arrival_method
        delete form.arrival_notes
        delete form.arrival_time
        delete form.arrival_date
        delete form.arrival_confirmed
        delete form.arrival_ticket
        delete form.arrival_no_transfer
        delete form.arrival_no_transfer_reason
        if (form.departure_method !== 'flight') {
          form.departure_flight_number = null
          form.departure_ticket = null
          form.departure_flight_domestic = false
        } else {
          if (form.departure_ticket && form.departure_ticket.file) form.departure_ticket = form.departure_ticket.id
          else form.departure_ticket = null
        }
        if (form.departure_method !== 'flight' && form.departure_method !== 'bus') form.departure_company = null
        if (form.departure_company && typeof form.departure_company === 'object') form.departure_company = form.departure_company.id
        if (form.departure_location) form.departure_location = form.departure_location.id
        if (form.departure_no_transfer_reason) form.departure_no_transfer_reason = form.departure_no_transfer_reason.code
        if (!form.departure_confirmed) {
          form.departure_no_transfer = false
          form.departure_no_transfer_reason = null
        }
      }
      return form
    },
    onChangeTransportMethod(type) {
      this.form[`${type}_company`] = ''
    },
    formatDate(date) {
      if (!date) return ''
      return format(parseISO(date), 'dd MMMM yyyy')
    },
    onShowModal(type) {
      this.transport_modal_type = type
      this.$v.form.$reset()
      this.$modal.show('transport-modal')
    },
    onHideModal() {
      this.$modal.hide('transport-modal')
    },
    onLocationSearch(search, loading) {
      loading(true)
      this.searchLocation(loading, search, this)
    },
    searchLocation: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.location_options = []
      } else {
        getGoogleSearch(search).then(response => {
          loading(false)
          vm.location_options = response.data
        })
      }
    }, 350),
  }
}
</script>

<style lang="sass" scoped>
.flight
  border-radius: 10px
  box-shadow: 0 1px 9px rgba(0, 0, 0, 0.1)
  background-color: #fff

.flight__holder
  display: flex
  align-items: flex-start
  width: 640px
  padding: 16px 16px 10px

.flight__icons
  display: flex
  align-items: center
  gap: 8px

.flight__footer
  display: flex
  align-items: center
  justify-content: space-between
  flex-wrap: wrap
  gap: 10px
  padding: 8px 16px
  border-top: 1px solid #e5e5e5

.flight__footer-right
  display: flex
  align-items: center
  gap: 10px

.flight__part
  display: flex
  align-items: flex-start
  gap: 14px
  width: 50%

  &:first-child
    padding-right: 16px
    border-right: 1px dashed #c1c1c1

  &:last-child
    padding-left: 16px

.flight__icon
  flex-shrink: 0
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15)
  line-height: 0
  border-radius: 50%

.flight__title
  display: flex
  justify-content: space-between
  align-items: center
  margin-bottom: 8px
  color: #5f5f5f
  font-size: 13px

.flight__date
  margin-bottom: 8px
  color: #181818
  font-weight: 600

.flight__name
  margin-bottom: 12px
  color: #181818
  font-size: 13px

  span
    font-weight: 500

.flight__text
  color: #5f5f5f
  font-size: 13px

.flight__note
  color: #439ad1
  font-size: 13px
  font-weight: 500

.flight__note--red
  display: block
  margin-bottom: 10px
  color: $color-error

.flight__button
  padding: 4px 10px 4px 29px
  border-radius: 8px
  border: 1px dashed #439ad1
  background-color: #fff
  background-image: url("~@/assets/img/pen-icon.svg")
  background-repeat: no-repeat
  background-position: left 10px top 5px
  color: #439ad1
  font-weight: 500

  &:hover
    border-style: solid

.flight__button--add
  background-image: url("~@/assets/img/add-flight-icon.svg")
  background-position: left 5px top 4px

.flight__additional
  display: flex
  align-items: center
  gap: 16px
  color: $color-theme
  font-size: 13px
  font-weight: 500

.flight__location
  margin-bottom: 10px
  color: #5f5f5f
  font-size: 13px

.flight__info
  flex-grow: 1

.flight__confirmed
  display: flex
  align-items: center
  gap: 7px
  color: $color-theme
  font-size: 13px
  font-weight: 500
</style>
